import { render, staticRenderFns } from "./PackagesCreate.vue?vue&type=template&id=84cb8636&scoped=true&"
import script from "./PackagesCreate.vue?vue&type=script&lang=js&"
export * from "./PackagesCreate.vue?vue&type=script&lang=js&"
import style0 from "./PackagesCreate.vue?vue&type=style&index=0&id=84cb8636&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84cb8636",
  null
  
)

export default component.exports